import React from "react"
import {BrowserRouter as Router, Route, Switch} from "react-router-dom"
import ResetRoot from "./components/Reset"
import Confirm from "./components/Confirm"
import Home from "./components/Home"
import "./App.scss"

const App: React.FC = () => {
	return (
		<div className={"flex-frame"}>
			<Router>
				<Switch>
					<Route exact path={`/confirm/:token?`} component={Confirm}/>
					<Route exact path={`/reset`} component={Home}/>
					<Route exact path={`/reset/:stage/:token?`} component={ResetRoot}/>
					<Route exact path={`/`} component={Home}/>
				</Switch>
			</Router>
		</div>
	)
}

export default App
